import classNames, {Argument} from 'classnames';
import React, {useState, useEffect} from 'react';

import styles from './DLNumberInput.less';

interface OwnProps {
  className?: Argument;
  inputRef?: React.LegacyRef<HTMLInputElement>;
  max?: number;
  onChange?: (value: number) => void;
  min?: number;
  step?: number;
  value?: number | string;
}

type Props = OwnProps;

const DLNumberInput: React.FC<Props> = ({
  className,
  inputRef,
  min,
  max,
  onChange,
  step = 1,
  value = '',
  ...restProps
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (e) => {
    if (e && e.target) {
      const newValue = Number(e.target.value);
      setInputValue(newValue);

      if (onChange) {
        onChange(newValue);
      }
    }
  };

  return (
    <input
      className={classNames(className, styles.DLNumberInput)}
      type={'number'}
      ref={inputRef}
      max={max}
      min={min}
      onChange={handleChange}
      step={step}
      value={inputValue}
      {...restProps}
    />
  );
};

DLNumberInput.displayName = 'DLNumberInput';

export default DLNumberInput;
